export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/index.js
// module id = 33
// module chunks = 3